export default __webpack_public_path__ + "static/media/geetoo-logo.760c7ca5.png";